import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {TeamContainerModel} from '../../../../../models/aggregates/team';
import { ApiVisa, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';

// https://api.akaun.com/core2/tnt/dm/teams/applet-login-ep/

@Injectable({
  providedIn: 'root'
})
export class TeamLoginEPService extends BaseApiTemplateService<TeamContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'teams/applet-login-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'teams/applet-login-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'teams/applet-login-ep';
    this.httpClient = http;
  }

  public getByGuidCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    guid: any,
  ): Observable<PagingResponseModel<TeamContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl +'/'+ guid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<TeamContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}
